import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=d6c18f60&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6c18f60')) {
      api.createRecord('d6c18f60', component.options)
    } else {
      api.reload('d6c18f60', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=d6c18f60&", function () {
      api.rerender('d6c18f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/common/loader.vue"
export default component.exports